// material-ui
//import {useTheme} from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 * import { ThemeMode } from 'config';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //
import * as React from "react";
import {getRouteUrl} from "../../../../helpers/getRouteUrl";
import {ROUTE_PAGE_HOME} from "../../../../routers/routes";
import {useHistory} from "react-router-dom";
import {useMultilingualText} from "../../../../hooks/useMultilingualText";
import {IMAGE_ICON} from "../../../../assets/images";

const LogoIcon = (props) => {

    const history = useHistory()
    const imageUrl = useMultilingualText(IMAGE_ICON)
    return (
        <>
            <img
                onClick={() => history.push(getRouteUrl(ROUTE_PAGE_HOME))}
                src={imageUrl}
                alt="logo"
                style={
                    {
                        //marginRight: "auto",
                        maxWidth: 60,
                        cursor: "pointer"
                    }
                }
            />
        </>
    )
};
export default LogoIcon;
